import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
    from{
        opacity:0;
    }
    to{
        opacity: 0.25;
    }
`;

export const Container = styled.div`
  min-width: ${props => `${props.minWidth}`};
  min-height: ${props => `${props.minHeight}` || "none"};
  border-radius: ${props => props.theme.br.pill};
  background-color: ${props => props.background || props.theme.backgroundLight};
  display: flex;
  align-items: center;
  position: relative;
  height: ${({ theme }) => theme.filters.height.default};
  padding: 0px 20px;
  cursor: pointer;
  opacity: ${props => (props.faded ? 0.25 : 1)};
  animation: ${props => (props.faded ? fadeIn : "")} 0.5s ease-in;
  overflow: ${props => (props.$isEntityTag ? "hidden" : "visible")};

  ${props =>
    props.$isEntityTag &&
    `
    &::before,
    &::after {
      content: "";
      position: absolute;
      inset: 0;
      pointer-events: none;
    }
    &::before {
      // white partial gradient layer
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.35) 0%,
        rgba(255, 255, 255, 0) 20%
      );
      z-index: 2;
    }
    &::after {
      // noise img layer
      background-image: url(${require("../../assets/noise.png")});
      background-repeat: repeat;
      mix-blend-mode: overlay;
      z-index: 3;
    }
  `}

  .range {
    position: absolute;
    background-color: ${({ theme }) => theme.primary};
    height: 100%;
    z-index: 1;
    left: ${({ starting, $isSingular }) =>
      $isSingular ? `calc(${starting} + 10% - 10.5px)` : starting};
    right: ${props => props.ending};
    width: ${({ width, $isSingular, theme, $circleSize }) =>
      $isSingular ? $circleSize || theme.filters.height.default : width};
    border-radius: ${({ theme }) => theme.br.pill};
  }

  .tag-icon {
    z-index: 2;
    margin-left: -${({ theme }) => theme.spacing[5]};
    margin-right: ${({ theme }) => theme.spacing[5]};
    flex-shrink: 0;
    align-self: center;
    box-sizing: border-box;
    height: ${({ theme }) => theme.filters.height.default};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .text {
    width: 100%;
    height: ${({ theme }) => theme.filters.height.default};
    text-align: center;
    display: flex;
    padding-top: 1px;
    justify-content: center;
    align-items: center;
    z-index: 2;
    font-family: ${({ theme }) => theme.p4b.ff};
    font-size: var(--tag-font-size, ${({ theme }) => theme.p4b.fs});
    letter-spacing: ${({ theme }) => theme.p4b.letterSpacing};
    color: ${({ theme, isActive, $onSearchFilter }) =>
      isActive || $onSearchFilter ? theme.textLight : theme.textMedium};
    white-space: nowrap;
    margin-left: ${({ closable }) => (closable ? "-5px" : "0px")};
    margin-right: ${({ $isEntityTag, closable, theme }) =>
      $isEntityTag ? theme.spacing[4] : closable ? theme.spacing[5] : "0px"};
  }

  .value {
    white-space: nowrap;
    margin-right: 8px;
    font-family: ${({ theme }) => theme.p4b.ff};
    font-size: ${({ theme }) => theme.p4b.fs};
    letter-spacing: ${({ theme }) => theme.p4b.letterSpacing};
    margin-left: ${({ closable }) => (closable ? "5px" : "0px")};
  }

  .close {
    position: absolute;
    right: ${props => (props.moveToRight ? "-6.4px" : "0px")};
    cursor: pointer;
    z-index: 1;
    width: 35px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    color: ${({ theme }) => theme.textLight};
    padding-right: 2px;
    margin-top: -2px;
  }
`;
